import { useEffect } from 'react';
import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { NavLink } from 'react-router-dom';
import { EmptyState, PageHeader } from '@routes-plan/ui';
import HeaderResponsive from '../../../components/layouts/HeaderResponsive';
import { useT } from '../../../i18n';
import { setPageTitle } from '../../../utils/pageTitle';

/**
 * Cargar archivo de clientes. La pantalla anterior solo tenía la selección de sede y rutas, sin
 * carga de archivo ni resultado; mientras se construye, se dice claramente que no está disponible.
 */
const ClientImport = () => {
  const t = useT();
  useEffect(() => {
    setPageTitle('clientImport.title');
  }, []);
  return (
    <HeaderResponsive>
      <PageHeader title={t('clientImport.title')} description={t('clientImport.subtitle')} />
      <Paper variant="outlined">
        <EmptyState icon={<UploadFileOutlinedIcon />} title={t('clientImport.unavailableTitle')} description={t('clientImport.unavailable')}
          action={
            <Button variant="outlined" component={NavLink} to="/processes/import">
              {t('clientImport.goToLoanImport')}
            </Button>
          }
        />
      </Paper>
    </HeaderResponsive>
  );
};

export default ClientImport;
